import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { HttpParams, HttpResponse } from '@angular/common/http';
import { LookupDetail } from 'src/app/core/models/lookup-detail.model';
import { LiftTypeService } from './lift-type.service';


@Injectable({ providedIn: 'root' })
export class LiftTypeLookupResolver implements Resolve<HttpResponse<LookupDetail[]>> {
  constructor(
    private liftTypeService: LiftTypeService
  ) { }

  resolve() {
    const httpParams = new HttpParams()
      .set('orderby', 'Title asc');
    return this.liftTypeService.get(httpParams);
  }
}
